import React, { useContext, useEffect, useState } from 'react';
import classes from './gameLogs.module.scss'
import { useQuery } from '../../hooks/useQuery';
import { getAdminDataRequest } from '../../httpRequests/consoleRequests';
import IAdmin, { ILobby } from '../../interfaces/admin';
import { CONSOLE_URL, CONSOLE_URL_ASIA, CONSOLE_URL_EU, CONSOLE_URL_US } from '../../consts/config';
import { AdminDataVM } from '../admin/admin';


function AdminLogsContainer() {
  const [adminData, setAdminData] = useState<AdminDataVM
  | null>(null)
  const query = useQuery()
  useEffect(() => {
      // @ts-ignore
    getAdminData( query.admin)
  }, [])
   const getAdminData = async (admin : string) => {
    const adminDataEu = await getAdminDataRequest(admin,  CONSOLE_URL_EU)
    const adminDataUs = await getAdminDataRequest(admin, CONSOLE_URL_US)
    const adminDataAsia = await getAdminDataRequest(admin, CONSOLE_URL_ASIA)
    setAdminData({
      serverStatus: {
        eu: 'offline' ,
        us: 'offline',
        asia: 'offline'
      },
      onlinePlayers: {
        us: adminDataUs.onlinePlayers,
        eu: adminDataEu.onlinePlayers,
      },
      activeLobbys:{
        us: adminDataUs.activeLobbys,
        eu: adminDataEu.activeLobbys,
      },
      activeGames:{
        us: adminDataUs.activeGames,
        eu: adminDataEu.activeGames,
      },
      lobbyData: [
        ...adminDataEu.lobbyData.map((data: ILobby) => ({
          ...data,
          region: 'EU'
        })),
        ...adminDataUs.lobbyData.map((data: ILobby) => ({
          ...data,
          region: 'US'
        })),
        ...adminDataAsia.lobbyData.map((data: ILobby) => ({
          ...data,
          region: 'ASIA'
        }))
      ],
      history: [
        ...adminDataEu.history.map((data: ILobby) => ({
          ...data,
          region: 'EU'
        })),
        ...adminDataUs.history.map((data: ILobby) => ({
          ...data,
          region: 'US'
        })),
        ...adminDataAsia.history.map((data: ILobby) => ({
          ...data,
          region: 'ASIA'
        }))
      ]

    })
   }

   if(!adminData) {
     return null
   }

   //@ts-ignore
   const roomNumber =query.roomNumber
      //@ts-ignore
      const region =query.region
      //@ts-ignore
  const lobby = query.history === "true"
        //@ts-ignore
  ? adminData.history.find(lobby => lobby.roomNumber === roomNumber && region.toLowerCase() === lobby.region.toLowerCase())
        //@ts-ignore
  : adminData.lobbyData.find(lobby => lobby.roomNumber === roomNumber && region.toLowerCase()=== lobby.region.toLowerCase())
  console.log("lobby", lobby)
  if(!lobby) {
    return null
  }
  return (
    <div className={ classes.wrapper}>
      {
                //@ts-ignore
        lobby.gamesPlayed[query.gameIndex].logs.map((log,index) => <div className={classes.log}>
            <div className={classes.number}> {index}.</div> {log}
          </div>)
      }
  </div>  
    
  );
}

export default AdminLogsContainer;
